import {
  FieldResponse,
  FieldArrayOfDoubleResponse,
  FieldArrayOfIntResponse,
  FieldBooleanResponse,
  FieldWithKeyValuePairStringIntResponse,
  FieldWithOptionsResponse,
  FieldWithOptionsMultiSelectResponse,
  FieldWithManualAreaResponse,
  FieldWithDeductionsResponse,
  FieldWithPositionResponse,
} from '../../.generated/admin-api';

export type FieldType =
  | FieldResponse
  | FieldArrayOfDoubleResponse
  | FieldArrayOfIntResponse
  | FieldBooleanResponse
  | FieldWithDeductionsResponse
  | FieldWithKeyValuePairStringIntResponse
  | FieldWithManualAreaResponse
  | FieldWithOptionsMultiSelectResponse
  | FieldWithOptionsResponse
  | FieldWithPositionResponse;

export type KeyValuePairIntIntFieldValue = Record<string, number>;
export type KeyValuePairStringIntFieldValue = Record<string, number>;

export type FieldValueState = {
  fieldId: string;
  value: unknown;
  isValid: boolean;
};

export const isInt32 = (number: number): boolean => {
  const minInt32 = -2147483648;
  const maxInt32 = 2147483647;

  return number >= minInt32 && number <= maxInt32;
};
